import { TTaskSource } from '../hooks/dto/taskItem.dto';

export interface SquadFilterConfig {
  sources: TTaskSource[];
}

export const SQUAD_DEFAULT_FILTERS: Record<string, SquadFilterConfig> = {
  PROJECTS: {
    sources: ['AUTOMATIONS', 'SCRIPTS', 'EXTERNAL'],
  },
  INTEGRATIONS: {
    sources: ['INTEGRATIONS', 'SCRIPTS'],
  },
  EXTENSIONS: {
    sources: ['EXTENSIONS', 'SCRIPTS'],
  },
};

export const getDefaultSourceFiltersBySquads = (userSquads: string[]): TTaskSource[] => {
  if (!userSquads || userSquads.length === 0) {
    return [];
  }

  const defaultSources = new Set<TTaskSource>();

  userSquads.forEach((squad) => {
    const squadConfig = SQUAD_DEFAULT_FILTERS[squad];
    if (squadConfig) {
      squadConfig.sources.forEach((source) => defaultSources.add(source));
    }
  });

  return Array.from(defaultSources).sort();
};
